import EnumProjectType from '../../../../projects/base/entities/enums/EnumProjectType';
import PageRequest from '../../../../pagination-helper/lib/PageRequest';

/**
 * * Модель для поиска по проектам
 */
export default class ProjectSearchRequest  {
	/**
	 * * Поиск по названию или части названия
	 */
	Name!: string;
	/**
	 * * Ид статусов проекта для фильтра
	 */
	Status!: Array<EnumProjectType>;
	/**
	 * * Постраничка
	 */
	Page!: PageRequest;
	/**
	 * * Для фильтра любимых проектов
	 */
	ShowOnlyFavourite: boolean = false;
	/**
	 * * Для фильтра где является исполнителем текущий пользователь
	 */
	ShowOnlyPerformerId?: number;
	/**
	 * * Для фильтра не пустых проектов (где есть хотя бы одна очередь)
	 */
	ShowOnlyNotEmpty: boolean = false;
	/**
	 * * Показать только те где текущий пользователь администратор
	 */
	ShowOnlyCurrentIsAdmin: boolean = false;
	constructor(obj?: Partial<ProjectSearchRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
